import { render, staticRenderFns } from "./consulence.vue?vue&type=template&id=ab75221a&"
import script from "./consulence.vue?vue&type=script&lang=js&"
export * from "./consulence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports